import * as XLSX from 'xlsx/xlsx.mjs';

$(document).ready(() => {
    const rABS = typeof FileReader !== 'undefined' && (FileReader.prototype || {}).readAsBinaryString;

    const process_data = (data) => {
        const processURL = $('#js-dropZone').data('import-url');
        const requestData = {
            ajax: '1',
            products: data
        };
        $.ajax({
            url: processURL,
            method: 'POST',
            dataType: 'json',
            data: requestData,
        }).then(function (resp) {
            console.log(resp);
            $('#actionError').html('');
            for (let error in resp.errors) {
                $('#actionError').append('<article class="alert alert-danger"><ul><li>' + resp.errors[error] + '</li></ul></article>');
            }
            for (let success in resp.successes) {
                $('#actionError').append('<article class="alert alert-info"><ul><li>' + resp.successes[success] + '</li></ul></article>');
            }
            $('#actionError').show();
            if (resp.success) {
                prestashop.emit('updateCart', {
                    resp: resp
                });
            }
        }).fail((resp) => {
            prestashop.emit('handleError', {
                eventType: 'addProductToCart',
                resp: resp
            });
        });
    }

    // Convert CSV data to json
    const to_json = (workbook) => {
        const result = {};
        workbook.SheetNames.forEach(function (sheetName) {
            const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {header: 1});

            if (roa.length) {
                result[sheetName] = roa;
            }
        });

        return JSON.stringify(result, 2, 2);
    };

    // Process Work Book (CSV Data)
    const process_wb = (wb) => {
        process_data(to_json(wb));
    };

    // Process file
    const do_file = (files) => {
        const f = files[0];
        const reader = new FileReader();
        reader.onload = (e) => {
            let data = e.target.result;

            if (!rABS) {
                data = new Uint8Array(data);
            }

            process_wb(XLSX.read(data, {type: rABS ? 'binary' : 'array'}));
        };

        if (rABS) {
            reader.readAsBinaryString(f);
        } else {
            reader.readAsArrayBuffer(f);
        }
    };

    var table = $('#products-list');
    if (!$.fn.DataTable.isDataTable(table)) {
        let columns = [
            {data: 'manufacturerName'},
            {data: 'reference'},
            {data: 'name'},
            {data: 'unitPrice'},
            {data: 'quantity'},
            {data: 'totalPrice'},
            {data: 'actions'}
        ];
        let order = [[2, 'asc']];
        table = table.DataTable({
            processing: false,
            serverSide: true,
            searching: true,
            ajax: {
                url: table.find('tbody').attr('data-refresh-datatable'),
                type: 'POST',
                // data: function(d){
                //     if($('.card-total').data("controller") && $('.card-total').data("controller") === "cart"){
                //         d.page_event = 'vi_see_selection'
                //     }
                // }
            },
            language: {
                url: '//cdn.datatables.net/plug-ins/9dcbecd42ad/i18n/'
                    + getLanguageName(prestashop.language.language_code)
                    + '.json'
            },
            dom: 'rtip',
            ordering: false,
            lengthMenu: [20, 35, 50, 100, 1000],
            responsive: true,
            columnDefs: [
                { targets: 0, responsivePriority: 6, className: "all cell-manufacturer-logo", width: '50px'  },
                { targets: 1, responsivePriority: 1, className: "all"},
                { targets: 2, responsivePriority: 7  },
                { targets: 3, responsivePriority: 3,  className: "cell-price all" },
                { targets: 4, responsivePriority: 2,  className: "cell-qty all",  width: '150px' },
                { targets: 5, responsivePriority: 4,  className: "cell-price all"},
                { targets: 6, responsivePriority: 5,  className: "cell-actions all"},
            ],
            autoWidth: false,
            "searchCols": [
                table.data('type') === 'oem' ? null : { "search": "top-collect" },
                null,
                null,
                null,
                null,
                null,
                null
            ],
            columns: columns,
            order: order
        });

        table.on('draw', function(){
            $.each($('input[name="product-quantity-spin"]'), function (index, spinner) {
                $(spinner).TouchSpin({
                    buttondown_class: 'btn js-touchspin',
                    buttonup_class: 'btn js-touchspin',
                    min: parseInt($(spinner).attr('min'), 10),
                    max: 1000000
                });
            });

            $('.remove-from-cart').click(function() {
                var input = $(this).parents('tr:first').find('.js-cart-line-product-quantity');
                input.val(0).trigger('change');
            });
        });

        $(document).on('keyup', '#search-printer', (event, brand) => {
            if ($(event.currentTarget).val() !== '') {
                let allBrand = $('.brand img[data-search=""]').parent();
                if (!allBrand.hasClass('selected')) {
                    $('.brand').removeClass('selected');
                    allBrand.addClass('selected');
                }
            }

            if (brand !== 'brand') {
                table.search($(event.currentTarget).val()).draw();
            }
        });

        $(document).on('click', '.brand', (event) => {
            let search = '';

            if ($(event.currentTarget).hasClass('selected')) {
                let allBrand = $('.brand img[data-search=""]').parent();
                $('.brand').removeClass('selected');
                allBrand.addClass('selected');
                search = allBrand.find('img:first').data('search');
            } else {
                $('.brand').removeClass('selected');
                $(event.currentTarget).addClass('selected');
                search = $('img', event.currentTarget).data('search');
            }

            $('#search-printer').val('').trigger('keyup', ['brand']);
            table.columns(0).search(search).draw();
        });

        $(document).on('click', '.btn-see-my-selection', (event) => {
            $(event.currentTarget).hide();
            $('.see-my-selection').hide();
            //$('.continue-my-selection').show();
            $('#search-printer').val('');
            $('.brand').removeClass('selected');
            table.columns(0).search('').draw();
            table.column(5).search('^[^0].*$', true, false).draw();
        });

        $(document).on('click', '.btn-continue-my-selection', () => {
            $('.continue-my-selection').hide();
            $('.see-my-selection').show();
            table.columns(5).search('').draw();
        });
    }

    let confirmModal = $('#vi-confirm-modal');
    $(document).on('click', '#btn-clear-selection', (event) => {
        confirmModal.modal('show');
    });

    confirmModal.on('hidden.bs.modal', function () {
        confirmModal.remove();
    });

    confirmModal.on('shown.bs.modal', function () {
        let btnConfirm = $('#btn-clear-selection');
        let linkConfirm = $('#link-clear-selection');

        linkConfirm.attr('href', btnConfirm.attr('data-href'))
        linkConfirm.attr('data-link-action', btnConfirm.attr('data-action'))

        $(document).on('click', linkConfirm, (event) => {
            confirmModal.modal('hide');
        });
    });

    $(document).on('dragenter', '#dropZone', (event) => {
        event.stopPropagation();
        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'copy';
    });

    $(document).on('dragover', '#dropZone', (event) => {
        event.stopPropagation();
        event.preventDefault();
        event.originalEvent.dataTransfer.dropEffect = 'copy';
    });

    $(document).on('drop', '#dropZone', (event) => {
        event.stopPropagation();
        event.preventDefault();
        do_file(event.originalEvent.dataTransfer.files);
    });

    $(document).on('change', '#js-dropZone', (event) => {
        do_file(event.target.files);
        $(event.currentTarget).val('');
    });

    $(document).on('click', '#dropZone', () => {
        $('#js-dropZone').click();
    });

    $(document).on('click', '.solution-modal', (event) => {
        event.stopPropagation();
        event.preventDefault();
        $('#solution-modal').modal('show');
    });

    const $quantityInput = $('.product-search-widget__quantity');
    $quantityInput.TouchSpin({
        buttondown_class: 'btn btn-touchspin js-touchspin',
        buttonup_class: 'btn btn-touchspin js-touchspin',
        min: parseInt($quantityInput.attr('min'), 10),
        max: 1000000
    });

    const setWidgetReady = ($widget, qt) => {
        const $addToCart = $('.product-search-widget__add', $widget);
        const add_url = $addToCart.attr('data-base-url') + '&qty=' + qt;
        $widget.addClass('ready');
        $addToCart.attr('data-cart-url', add_url).prop('disabled', false);
    }

    const setWidgetNotReady = ($widget) => {
        console.log('setWidgetNotReady', $widget);

        if ($widget.hasClass('ready')) {
            const REF_PLACEHOLDER_DEFAULT = 'Ref';
            $widget.removeClass('ready');
            $('.product-search-widget__add', $widget).attr('data-cart-url', '').prop('disabled', true);
            $('.product-search-widget__quantity', $widget).val(1);
            $('.product-search-widget__input', $widget).val('').attr('placeholder', REF_PLACEHOLDER_DEFAULT).focus();
        }
    }

    $(document).on('change keyup', '.product-search-widget__quantity', (e) => {
        $(e.currentTarget).trigger('touchspin.stopspin');
        const $widget = $(e.currentTarget).closest('.product-search-widget');
        const qt = e.target.value;
        const $addToCart = $('.product-search-widget__add', $widget);
        const add_url = $addToCart.attr('data-base-url');

        if (typeof add_url === typeof undefined || add_url === false || add_url === '') {
            console.log('Qt change but no product selected');
            setWidgetNotReady($widget);
        } else {
            setWidgetReady($widget, qt);
            $('.product-search-widget__quantity', $widget).focus();
        }
    });

    $.widget('prestashop.productSearchWidgetSearchAutocomplete', $.ui.autocomplete, {
        _renderItem: function (ul, product) {
            ul.addClass('resultsearchtop');
            let imageprodsearch = '';
            let priceHtml = '';
            let attributes = '';

            if (product.cover !== null && product.cover !== false) {
                imageprodsearch = '<img src="' + product.cover.small.url + '">';
            }

            if (product.price_amount > 0) {
                priceHtml += '<span class="flex flex-row align-baseline"></pans><span>' + product.price + '</span><span class="taxes-label"> HT</span></span>';
            }

            if (typeof product.attributes !== 'undefined') {
                for (const attribute in product.attributes) {
                    if (product.attributes.hasOwnProperty(attribute)) {
                        attributes += ' - ' + product.attributes[attribute].group + ' : ' + product.attributes[attribute].name;
                    }
                }
            }

            const liHtml = '<li class="searchprodtop"><a><span class="searchprodimg">' + imageprodsearch + '</span><span class="product">' + product.name + '</span><span class="searchprodprice flex-column">' + priceHtml + '</span></a></li>';

            return $(liHtml).appendTo(ul);
        }
    });

    $(document).on('keydown', '.product-search-widget__input', function (event) {
        if (event.keyCode !== 13) {
            const $widget = $(this).closest('.product-search-widget');
            setWidgetNotReady($widget);

            $(this).productSearchWidgetSearchAutocomplete({
                minLength: 3,
                autoFocus: true,
                appendTo: $(this).closest('form'),
                source: function (query, response) {
                    const searchURL = this.element.attr('data-search-controller-url');
                    $.post(searchURL, {
                        s: query.term,
                        resultsPerPage: 10,
                        type: this.element.attr('data-type')
                    }, null, 'json')
                    .then(function (resp) {
                        response(resp.products);
                    })
                    .fail(response);
                },
                select: function (event, ui) {
                    const $input_zone = $(this);
                    let minimal_quantity = parseInt(ui.item.minimal_quantity);
                    minimal_quantity = minimal_quantity < 1 ? 1 : minimal_quantity;
                    $('.product-search-widget__quantity', $widget).val(minimal_quantity);
                    $('.product-search-widget__quantity', $widget).trigger('touchspin.updatesettings', {
                        min: minimal_quantity
                    });
                    $input_zone.attr('placeholder', ui.item.reference);
                    $('.product-search-widget__add', $widget).attr('data-base-url', ui.item.add_to_cart_url)
                    setWidgetReady($widget, minimal_quantity);
                    $('.product-search-widget__quantity', $widget).focus().select();
                },
            });
        }
    });

    $(document).on('click', '.product-search-widget__add', (event) => {
        console.log('.product-search-widget__add click', event);
        event.preventDefault();
        const $target = $(event.currentTarget);
        const requestURL = $target.attr('data-cart-url')
        const $widget = $target.closest('.product-search-widget');
        setWidgetNotReady($widget);
        $.post(requestURL, {ajax: '1'}).then((resp) => {
            prestashop.emit('updateCart', {
                reason: {},
                resp: resp
            });
        }).fail((resp) => {
            prestashop.emit('handleError', {
                eventType: 'addProductToCart',
                resp: resp
            });
        });
    });

  prestashop.on('updateCart', (event) => {
    prestashop.cart = event.resp.cart;
    const getCartViewUrl = $('.js-datatable').data('refresh-url');
    if (!getCartViewUrl) {
      return;
    }

    let requestData = {};

    if (event && event.reason) {
      requestData = {
        id_product_attribute: event.reason.idProductAttribute,
        id_product: event.reason.idProduct,
      };
    }

      // Redraw table without reset pagination
      table.draw(false);
      $.post(getCartViewUrl, requestData)
      .then((resp) => {
        // if ($(window).width() < 700) {
        //   $('.cart-detailed-totals-mobile').replaceWith(
        //     resp.cart_detailed_totals_mobile,
        //   );
        // } else {
        //   $(prestashop.selectors.cart.detailedTotals).replaceWith(
        //     resp.cart_detailed_totals,
        //   );
        // }

        $(prestashop.selectors.cart.detailedTotals).replaceWith(
          resp.cart_detailed_totals,
        );

        prestashop.emit('updatedCart', {eventType: 'updateCart', resp});
      })
      .fail((resp) => {
        prestashop.emit('handleError', {eventType: 'updateCart', resp});
      });
  });

    prestashop.on('updatedCart', () => {
      $('.product-search-widget__quantity').TouchSpin({
        buttondown_class: 'btn btn-touchspin js-touchspin',
        buttonup_class: 'btn btn-touchspin js-touchspin',
        min: parseInt($quantityInput.attr('min'), 10),
        max: 1000000
      });
    });
});
